/* eslint-disable */

// react imports
import React, { useState, useEffect, useRef } from "react";

// react-router-dom components
import { useLocation, NavLink } from "react-router-dom";

// update path changes with router
import { useNavigate } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { List, Divider, Icon, CircularProgress } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import SidenavCollapse from "nav/Sidenav/SidenavCollapse";
// import SidenavStore from "nav/Sidenav/SidenavStore";

// Custom styles for the Sidenav
import SidenavRoot from "nav/Sidenav/SidenavRoot";
import sidenavLogoLabel from "nav/Sidenav/styles/sidenav";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  setUserStores,
  setCurrentStore,
  setActiveNavLink,
  setPageState,
} from "context";

// Firebase imports
import { getDocs, collection } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db, logout } from "../../Firebase";

function Sidenav({ color, brand, brandName, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  // add to below: sidenavColor
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    userStores,
    // activeNavLink,
    pageState,
  } = controller;

  const auth = getAuth();
  const userInfo = auth.currentUser;

  const navigate = useNavigate();
  const sidebarRef = useRef(0);

  const slugify = (str) => {
    return str
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const renameStudy = (str) => {
    return str.replace("J&JSAMPLE", "JNJ-SAMPLE").replace("_STUDY", "-study").toLowerCase();
  };

  // pageState set
  useEffect(() => {
    if (dispatch){
      const pathname = window.location.pathname || "";
      if (pathname === "/address-book"){
        setPageState(dispatch, "AddressBook");
      } else if (pathname === "/checkout"){
        setPageState(dispatch, "Checkout");
      } else if (pathname === "/orders"){
        setPageState(dispatch, "Orders");
      } else if (pathname === "/contact"){
        setPageState(dispatch, "Contact");
      } else {
        if (userStores && userStores.length > 0){
          let foundStore = false;
          for (let i = 0; i < userStores.length; i++) {
            const store = userStores[i];
            const slug = slugify(store);
            const renamed = renameStudy(store);
            if (pathname === `/${renamed}`) {
              foundStore = true;
              setPageState(dispatch, userStores[i]);
              if (sidebarRef.current){
                const targetLink = sidebarRef.current.querySelector(`[id="navlink-${userStores[i]}"]`);
                if (targetLink) {
                  targetLink.click();
                }
              }
            }
          }
          if (!foundStore) {
            setPageState(dispatch, userStores[0]);
          }
          const DashArray = [...userStores, "Dashboard"];
          console.log(DashArray.includes(userStores[0]));
          console.log(pageState);
        }
      }
    }
  }, [dispatch, userStores]);

  const location = useLocation();
  // const collapseName = location.pathname.replace("/", "");

  const [storeNotLoaded, setStoreNotLoaded] = useState(true);
  const [inactiveStudies, setInactiveStudies] = useState([]);
  const [studyNames, setStudyNames] = useState({});

  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  const [smallWindow, setSmallWindow] = useState(window.innerWidth < 1200);
  useEffect(() => {
    const handleResize = () => {
      const isSamller = window.innerWidth < 1200;
      setSmallWindow(isSamller);
      setMiniSidenav(dispatch, isSamller);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      // setMiniSidenav(dispatch, window.innerWidth < 1200); // <- Temporarily disabling this, because it is honestly an annoying user experience
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  useEffect(() => {
    const getStoreDocs = async () => {
      const storeUser = userInfo.uid;
      const inactiveColRef = await getDocs(collection(db, "STUDY_INACTIVE"));
      const _inactiveStudies = inactiveColRef.docs.map((el) => el.id);
      setInactiveStudies(_inactiveStudies);
      const colRef = await getDocs(collection(db, "USERS", storeUser, "STUDIES"));
      const userStudies = colRef.docs.map((el) => el.id).filter(item => !_inactiveStudies.includes(item));
      const _studyNames = {}
      const inventorySnapshot = await getDocs(collection(db, "STUDY_INVENTORY"));
      inventorySnapshot.forEach((doc) => {
        const docId = doc.id;
        const data = doc.data();
        const isCached = doc.metadata.fromCache;
        _studyNames[docId] = data.title || docId;
      });
      setStudyNames(_studyNames);
      setUserStores(dispatch, userStudies);
      setStoreNotLoaded(false);
    };
    getStoreDocs();
  }, []);

  useEffect(() => {
    setActiveNavLink(dispatch, userStores[0]);
  }, [userStores]);

  const renderUserStores = userStores.map((el) => {
    return (
      <>
        {!inactiveStudies.includes(el) && <>
          <SidenavCollapse
            id={`navlink-${el}`}
            name={studyNames[el] ? studyNames[el].toUpperCase() : el.replace(/_/g, " ")}
            icon="arrow_forward"
            active={pageState === el}
            color="white"
            onClick={() => {
              const slug = slugify(el);
              const renamed = renameStudy(el);
              setCurrentStore(dispatch, el);
              setActiveNavLink(dispatch, el);
              // closeSidenav(); // <- Temporarily disabling this, because it is honestly an annoying user experience
              setPageState(dispatch, el);
              navigate(`/${renamed}`);
            }}
          />
        </>}
      </>
    );
  });

  return (
    <SidenavRoot
      {...rest}
      ref={sidebarRef}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
    >
      <MDBox pt={3} pb={1} px={4} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <MDBox
          to="/"
          display="flex"
          alignItems="center"
          onClick={() => {
            setCurrentStore(dispatch, userStores[0]);
            setPageState(dispatch, userStores[0]);
          }}
          sx={{ cursor: "pointer" }}
        >
          {brand && <MDBox component="img" src={brand} alt="Brand" width="1.5rem" mx={1} />}
          <MDBox
            width={!brandName && "100%"}
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
              {brandName}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />
      <List>
        {storeNotLoaded && (
          <MDBox px={2}>
            <CircularProgress color="white" />
          </MDBox>
        )}
        {renderUserStores}
      </List>
      <List>
        <Divider light />
        <SidenavCollapse
          name="Checkout"
          icon={<Icon fontSize="small">shopping_cart_checkout</Icon>}
          active={["Checkout", "Shipping", "Review", "Customization"].includes(pageState)}
          onClick={() => {
            // closeSidenav(); // <- Temporarily disabling this, because it is honestly an annoying user experience
            setPageState(dispatch, "Checkout");
            navigate('/checkout');
          }}
        />
        <SidenavCollapse
          name="Your Orders"
          icon={<>
          {/* <div style={{ position: 'relative' }}>
            <Icon fontSize="small">card_travel</Icon>
            <div style={{ position: 'absolute', top: '50%', left: '100%', background: '#ff6726', width: '8px', height: '8px', borderRadius: '100%', transform: 'translate(-4px, -2px)' }} />
          </div> */}
          <Icon fontSize="small">card_travel</Icon>
          </>}
          active={pageState === "Orders"}
          onClick={() => {
            // closeSidenav(); // <- Temporarily disabling this, because it is honestly an annoying user experience
            setPageState(dispatch, "Orders");
            navigate('/orders');
          }}
        />
        <SidenavCollapse
          name="Address Book"
          icon={<Icon fontSize="small">book</Icon>}
          active={["AddressBook", "AddressPlus"].includes(pageState)}
          onClick={() => {
            // closeSidenav(); // <- Temporarily disabling this, because it is honestly an annoying user experience
            setPageState(dispatch, "AddressBook");
            navigate('/address-book');
          }}
        />
        <SidenavCollapse
          name="Contact"
          icon={<Icon fontSize="small">contacts</Icon>}
          active={["Contact", "ContactSuccess"].includes(pageState)}
          onClick={() => {
            // closeSidenav(); // <- Temporarily disabling this, because it is honestly an annoying user experience
            setPageState(dispatch, "Contact");
            navigate('/contact');
          }}
        />
        <NavLink key="sign-out" to="/authentication/sign-in">
          <SidenavCollapse
            name="Sign Out"
            icon={<Icon fontSize="small">login</Icon>}
            onClick={() => {
              // closeSidenav(); // <- Temporarily disabling this, because it is honestly an annoying user experience
              setActiveNavLink(dispatch, "sign-in");
              logout();
            }}
          />
        </NavLink>
      </List>
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
};

export default Sidenav;
